import { render, staticRenderFns } from "./TeamDialog.vue?vue&type=template&id=6d585e54&scoped=true"
import script from "./TeamDialog.vue?vue&type=script&lang=js"
export * from "./TeamDialog.vue?vue&type=script&lang=js"
import style0 from "./TeamDialog.vue?vue&type=style&index=0&id=6d585e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d585e54",
  null
  
)

export default component.exports